import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import classNames from 'classnames';
import style from './ApplicantsPerSeatPillBox.scss';

const ApplicantsPerSeatPillBox = ({ applicantsPerSeat }) => {
  // Sam -- 3 or fewer: 1 cell, 4-9: 2 cells, 10 or more: 3 cells
  const rootClasses = [style.root];
  // changing applicantsPerSeat calculation : MYS-917
  if (applicantsPerSeat <= 1) {
    rootClasses.push(style.fill1);
  } else if (applicantsPerSeat == 2) {
    rootClasses.push(style.fill2);
  } else if (applicantsPerSeat >= 3) {
    rootClasses.push(style.fill3);
  }

  return (
    <div className={classNames(...rootClasses)}>
      <div className={style.pillBox} />
      <div className={style.pillBox} />
      <div className={style.pillBox} />
    </div>
  );
};

ApplicantsPerSeatPillBox.propTypes = {
  applicantsPerSeat: PropTypes.number.isRequired,
};

export default withStyles(style)(ApplicantsPerSeatPillBox);
